export default __webpack_public_path__ + "static/media/word_icon.69287a9d.svg";